var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHecoBc = function SvgHecoBc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1228_77363",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 94,
    height: 94
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H94V94H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1228_77363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0204 3.41338C43.9846 2.8115 44.3876 3.04163 44.4145 3.05048C50.066 7.27255 57.5 20.2397 57.5 35.3135C57.5 51.5911 31.0872 66.594 33.0308 86.2526C34.634 102.522 47.0924 110.222 36.9717 107.443C18.8886 102.477 1.12793 75.5871 20.2231 51.06C28.4989 40.4295 43.5457 32.543 44.0114 3.43109C44.0114 3.42224 44.0204 3.42224 44.0204 3.41338ZM68.6303 45.1264C68.7471 44.9402 68.9086 44.9932 69.0255 45.0734C72.7874 48.2584 83.3547 59.2153 81.8554 76.5956C80.3201 94.5439 66.0985 102.422 65.506 102.715C57.9194 106.477 60.9541 110.159 57.9194 106.477C52.685 100.142 43.3835 88.3423 59.7059 63.873C64.5182 56.6601 68.3161 48.7996 68.6303 45.1264Z",
    fill: "white",
    fillOpacity: 0.2
  }))));
};

export { SvgHecoBc as ReactComponent };
export default __webpack_public_path__ + "2b949c5bd93b216772fc6d75beee72f2.svg";